import React from "react";
import "Styles/Global/PackageCard.scss";
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
} from "@ionic/react";
import { to_dollars_cents } from "Utils";

const consultationLabel = (count) =>
  count + " consultation" + (count === 1 ? "" : "s");

const splitDescriptionAndTagline = (description, tagline) => {
  const descriptionText = (description || "").trim();
  const metadataTagline = (tagline || "").trim();
  const taglineIndex = descriptionText.toLowerCase().indexOf("great for:");

  if (taglineIndex === -1) {
    return { description: descriptionText, tagline: metadataTagline };
  }

  return {
    description: descriptionText.slice(0, taglineIndex).trim(),
    tagline: metadataTagline || descriptionText.slice(taglineIndex).trim(),
  };
};

const PackageCard = ({ package_data, is_selected, ...rest }) => {
  const { dollars, cents } = to_dollars_cents(package_data.price_cents);
  const copy = splitDescriptionAndTagline(
    package_data.description,
    package_data.tagline
  );

  return (
    <IonCard
      className={`package-card ${is_selected ? "selected" : ""}`}
      {...rest}
    >
      {is_selected && (
        <div className="selected-icon">
          <div className="inner">
            <i className="material-icons">done</i>
          </div>
        </div>
      )}
      <IonCardHeader className="title">
        <div className="heading-row">
          <IonCardTitle>{package_data.name}</IonCardTitle>
          <span
            className="price"
            aria-label={"Price: $" + dollars + "." + cents}
          >
            $<strong>{dollars}</strong>.<span>{cents}</span>
          </span>
        </div>
        <IonCardSubtitle className="title-consultation-count">
          {consultationLabel(package_data.included_consultations_count)}
        </IonCardSubtitle>
      </IonCardHeader>
      <article
        className="image"
        style={{ backgroundImage: "url(" + package_data.image.url + ")" }}
      />
      <IonCardContent>
        <div className="description-slot">
          <p className="description">{copy.description}</p>
        </div>
        {copy.tagline && <p className="tagline">{copy.tagline}</p>}
      </IonCardContent>
    </IonCard>
  );
};

export default PackageCard;
